import { withScenarioQuery } from "features/shared/lib/technical-config-tab/api/withScenarioQuery";
import { ProjectId } from "features/shared/model/types";

const url = `${process.env.REACT_APP_ENERGY_DASHBOARD_API_URL}/api/technicaltab`;

export default {
  groupDetail: (projectId: ProjectId, userDefinedType: string, scenario?: string) =>
    withScenarioQuery(
      `${url}/projects/${projectId}/window-user-defined-types/${encodeURIComponent(userDefinedType)}`,
      scenario
    ),
  groups: (projectId: ProjectId, scenario?: string) =>
    withScenarioQuery(`${url}/projects/${projectId}/window-user-defined-types`, scenario),
  shadingCatalog: (windowTypeDbId?: number, activeOnly = true) => {
    const params = new URLSearchParams({ activeOnly: String(activeOnly) });
    if (windowTypeDbId != null) params.set("windowTypeDbId", String(windowTypeDbId));
    return `${url}/shading-system-db?${params.toString()}`;
  },
  windowCatalog: (activeOnly = true) => `${url}/window-type-db?activeOnly=${activeOnly}`,
};
